<script setup lang="ts">
// `spread` : la colonne est seule à l'écran, ses cartes se répartissent en colonnes au lieu de s'empiler.
defineProps<{ title: string; count: number; spread?: boolean }>();
</script>

<template>
  <section class="flex w-full min-w-0 flex-col gap-4 lg:min-h-0 lg:flex-1">
    <header class="flex items-center gap-3 px-1 py-2">
      <h2 class="text-[18px] leading-[1.2] font-semibold">{{ title }}</h2>
      <span
        class="bg-carte flex h-[26px] items-center rounded-[12px] px-2 text-[14px] leading-[1.4] font-semibold"
      >
        {{ count }}
      </span>
    </header>
    <!-- En colonnes, chaque liste défile seule et son titre reste en place. -->
    <div
      class="no-scrollbar gap-4 lg:min-h-0 lg:flex-1 lg:overflow-y-auto lg:overscroll-contain lg:pb-6"
      :class="
        spread
          ? 'grid grid-cols-1 content-start items-start sm:grid-cols-2 lg:grid-cols-3'
          : 'flex flex-col'
      "
    >
      <slot />
    </div>
  </section>
</template>
